module.exports = __webpack_public_path__ + "static/media/green_tick.382fff7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/green_tick.svg
// module id = 1187
// module chunks = 0